
import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useIsMobile } from "@/hooks/use-mobile";

interface ContentCarouselProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  viewAllLink?: string;
  viewAllText?: string;
}

function ContentCarousel<T>({ 
  items, 
  renderItem,
  viewAllLink,
  viewAllText = "Voir tout"
}: ContentCarouselProps<T>) {
  const isMobile = useIsMobile();
  
  if (!items || items.length === 0) {
    return (
      <div className="flex justify-center items-center py-8">
        <Skeleton className="h-12 w-32" />
      </div>
    );
  }

  return (
    <div className="pb-8">
      <Carousel opts={{
          align: "start",
          loop: false,
          dragFree: false
        }}>
        <CarouselContent className="-ml-4">
          {items.map((item, index) => (
            <CarouselItem 
              key={index}
              className={`pl-4 ${isMobile ? 'basis-full sm:basis-1/2' : 'basis-1/2 md:basis-1/3 lg:basis-1/4'}`}
            >
              {renderItem(item)}
            </CarouselItem>
          ))}
        </CarouselContent>
        
        <div className="flex justify-end mt-4">
          <div className="flex gap-2">
            <CarouselPrevious className="relative static translate-y-0 translate-x-0 left-0 right-0" />
            <CarouselNext className="relative static translate-y-0 translate-x-0 left-0 right-0" />
          </div>
        </div>
      </Carousel>
    </div>
  );
}

export default memo(ContentCarousel);
